import { js } from 'libs/js-beautify'

export const jsBeautify = (value, options = {}) => js(value, options)
